import React from 'react';
const IconNavInterfaces = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M10 20H4.01999V4H20V14L22 16V2H2V22H10V20ZM12 22V10L22 18.7857L15.8322 18.7769L15.6363 18.926L12 22ZM6 6H8V8H6V6ZM18 6H10V8H18V6Z" fill="#2D2E2E"/>
</svg>);
};
export default IconNavInterfaces;